export const RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS =
	'JSM_CUSTOMER_AUTHENTICATION_SETTINGS';
export const ONE_DAY_IN_MILLIS: number = 1000 * 60 * 60 * 24;
